import * as React from 'react';
import Lazy from 'lazy.js';
import { Component } from 'react';
import BPromise from 'bluebird';
import propz from 'propz';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { TwoPanelEditor } from 'Src/components/TwoPanelEditor/TwoPanelEditor';
import { Loader } from 'Src/components/Loader/Loader';
import { DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE, LIMIT } from 'Src/consts/table';
import { getTwoPanelEditorFilters } from 'Src/helpers/twoPanelEditor/twoPanelEditor';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import {
  ColumnDefinition,
  getOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  getAllSchoolTeamPlayers,
  getSchoolStudentsWithClashesCount,
  getSchoolStudentsWithoutClashes,
  getSchoolTeamPlayersCount,
  updateSchoolTeamPlayersBatch
} from 'Src/helpers/service/admin/schoolTeamPlayers';
import { AppUser } from 'Src/views/App/App';
import { SchoolForm } from 'Src/models/form';
import { getAge, getGender } from 'Src/helpers/accessor/accessor';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getUserGenderArrayConvertedFromEventGender } from 'Src/helpers/tournament/tournament';
import {
  getSelectOptionForAge,
  getSelectOptionForForms,
  getSelectOptionForGender,
  getSelectOptionForHouses
} from 'Src/helpers/table/select';
import { getAllHouses } from 'Src/helpers/service/admin/houses';
import { getSchoolTeam } from '../../../../../helpers/service/admin/schoolTeams';
import { Team, TeamPlayer } from '../../../../../models/team';
import { SchoolHouse } from '../../../../../models/house';
import { AGE_GROUPS } from '../../../../../consts/school';
import './SchoolTeamPlayers.css';
interface Props {
  user: AppUser;
  history: History;
  location: Location;
}
interface State {
  items: Item[];
  itemsSelected: Item[];
  itemsCount: number;

  itemsFilters: any;
  isShowItemsFilter: boolean;
  isItemsFiltered: boolean;

  isExitConfirmationModalOpen: boolean;

  isSelectAllItemsChecked: boolean;

  sortItemsDirection: TABLE_SORT_DIRECTION;
  sortItemsColumnsName: string;

  itemCurrentPage: number;

  itemsAccumulatorInitial: Item[];
  itemsAccumulator: Item[];
  itemsAccumulatorSelected: Item[];
  itemsAccumulatorCount: number;

  itemsAccumulatorFilters: any;
  isShowItemsAccumulatorFilter: boolean;
  isItemsAccumulatorFiltered: boolean;

  isSelectAllItemsAccumulatorChecked: boolean;

  sortItemsAccumulatorDirection: TABLE_SORT_DIRECTION;
  sortItemsAccumulatorColumnsName: string;

  team: Team;
  forms: SchoolForm[];
  houses: SchoolHouse[];

  isLoading: boolean;
  isItemsLoading: boolean;
  itemsSearch: string;

  itemsAddBuffer: Item[];
  itemsRemoveBuffer: Item[];
  assignmentChangedPlayerIds: string[];
  selectedRosterSportId: string;
  updateFutureEvents: boolean;
  saveError: string;
  saveResult?: { updatedEvents?: number };

  itemsHiddenFields: Set<string>;
  itemsAccumulatorHiddenFields: Set<string>;
}

const ITEMS_ACCUMULATOR_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['form', 'name']
  },
  {
    text: 'House',
    field: 'house',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['house', 'name']
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getAge
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getGender
  }
];

const ITEMS_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['form', 'name']
  },
  {
    text: 'House',
    field: 'houses',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['house', 'name']
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAge
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  }
];

interface Item {
  permissionId: string;
  form: any;
  house: any;
  gender: string;
  firstName: string;
  lastName: string;
  id: string;
  playerId?: string;
  sportIds?: string[];
  positionsBySport?: Array<{
    sportId: string;
    positionId?: string;
    positionName?: string;
    sub?: boolean;
    isCaptain?: boolean;
    isViceCaptain?: boolean;
  }>;
}

const DEFAULT_TEAM_PLAYERS_ORDER = 'firstName ASC';

export class SchoolTeamPlayers extends Component<Props, State> {
  private itemsSearchRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      itemsCount: 0,
      itemsSelected: [],

      itemsFilters: {},
      isShowItemsFilter: false,
      isItemsFiltered: false,

      isExitConfirmationModalOpen: false,

      isSelectAllItemsChecked: false,

      sortItemsDirection: '',
      sortItemsColumnsName: '',

      itemCurrentPage: 1,

      itemsAccumulatorInitial: [],
      itemsAccumulator: [],
      itemsAccumulatorCount: 0,
      itemsAccumulatorSelected: [],

      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,

      isSelectAllItemsAccumulatorChecked: false,

      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',

      team: undefined,
      forms: [],
      houses: [],

      isLoading: true,
      isItemsLoading: false,
      itemsSearch: '',

      itemsAddBuffer: [],
      itemsRemoveBuffer: [],
      assignmentChangedPlayerIds: [],
      selectedRosterSportId: '',
      updateFutureEvents: true,
      saveError: '',

      itemsHiddenFields: this.loadHiddenFields('teamPlayers_items'),
      itemsAccumulatorHiddenFields: this.loadHiddenFields('teamPlayers_accumulator')
    };
  }

  private static ALWAYS_VISIBLE = new Set(['firstName', 'lastName', 'clashes']);

  private get storageUserId(): string {
    return this.props.user?.userId || 'anonymous';
  }

  private loadHiddenFields(key: string): Set<string> {
    const userId = this.props.user?.userId || 'anonymous';
    try {
      const raw = localStorage.getItem(`columnVisibility__${userId}__${key}`);
      if (!raw) return new Set();
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return new Set<string>(parsed);
    } catch {}
    return new Set();
  }

  private saveHiddenFields(key: string, fields: Set<string>): void {
    try {
      localStorage.setItem(`columnVisibility__${this.storageUserId}__${key}`, JSON.stringify(Array.from(fields)));
    } catch {}
  }

  isColumnToggleable = (field: string): boolean => !SchoolTeamPlayers.ALWAYS_VISIBLE.has(field);

  onToggleItemsColumn = (field: string): void => {
    if (SchoolTeamPlayers.ALWAYS_VISIBLE.has(field)) return;
    this.setState(prev => {
      const next = new Set(prev.itemsHiddenFields);
      next.has(field) ? next.delete(field) : next.add(field);
      this.saveHiddenFields('teamPlayers_items', next);
      return { itemsHiddenFields: next };
    });
  };

  onToggleItemsAccumulatorColumn = (field: string): void => {
    if (SchoolTeamPlayers.ALWAYS_VISIBLE.has(field)) return;
    this.setState(prev => {
      const next = new Set(prev.itemsAccumulatorHiddenFields);
      next.has(field) ? next.delete(field) : next.add(field);
      this.saveHiddenFields('teamPlayers_accumulator', next);
      return { itemsAccumulatorHiddenFields: next };
    });
  };

  getTeamId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    return search.team;
  }

  getEditorMode(): 'roster' | 'assignments' {
    return parse(this.props.history.location.search).mode === 'assignments' ? 'assignments' : 'roster';
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const teamId = this.getTeamId();

    const itemsFilters = getTwoPanelEditorFilters(ITEMS_COLUMNS);
    const isShowItemsFilter = isFilterExist2(itemsFilters);

    const itemsAccumulatorFilters = getTwoPanelEditorFilters(ITEMS_ACCUMULATOR_COLUMNS);
    const isShowItemsAccumulatorFilter = isFilterExist2(itemsAccumulatorFilters);
    const isItemsAccumulatorFiltered = isFilterExist2(itemsAccumulatorFilters);

    let team: Team;

    getSchoolTeam(user, teamId)
      .then(_team => {
        team = _team;
        const { houseId, ages } = team;
        const isAgesExist = ages.length > 0;
        const isHouseIdExist = typeof houseId !== 'undefined';

        const formFilter = isAgesExist ? { age: { $in: ages } } : undefined;

        const houseFilter = isHouseIdExist ? { id: { $in: [houseId] } } : undefined;

        return BPromise.all([getAllForms(user, formFilter), getAllHouses(user, houseFilter)]);
      })
      .then(([forms, houses]) => {
        const defaultItemsFilter = this.getDefaultItemsFilter(team, forms, houses);

        this.setState({
          houses: houses,
          team: team,
          selectedRosterSportId: propz.get(team, ['sportIds', 0], propz.get(team, ['sportId'], '')),
          forms: forms,
          itemsFilters: defaultItemsFilter
        });

        return this.getItemsAndItemsAccumulator();
      })
      .then(({ teamPlayersInitial, teamPlayers, teamPlayersCount, students, studentsCount }) => {
        const studentsNormalized = this.getStudentsNormalized(students);
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        this.setState({
          items: studentsNormalized,
          itemsCount: studentsCount.count,
          isShowItemsFilter: isShowItemsFilter,
          isItemsFiltered: true,

          itemsAccumulatorInitial: teamPlayersInitialNormalized,
          itemsAccumulator: teamPlayersNormalized,
          itemsAccumulatorCount: teamPlayersCount.count,
          itemsAccumulatorFilters: itemsAccumulatorFilters,
          isShowItemsAccumulatorFilter: isShowItemsAccumulatorFilter,
          isItemsAccumulatorFiltered: isItemsAccumulatorFiltered,

          isLoading: false
        });
      });
  }

  getTeamPlayersNormalized(teamPlayers: TeamPlayer[]): Item[] {
    return teamPlayers.map(teamPlayer => {
      const {
        permissionId,
        form,
        gender,
        firstName,
        lastName,
        userId,
        id,
        house,
        sportIds,
        positionsBySport
      } = teamPlayer;
      return {
        permissionId,
        form,
        house,
        gender,
        firstName,
        lastName,
        id: userId,
        playerId: id,
        sportIds,
        positionsBySport
      };
    });
  }

  getStudentsNormalized(students): Item[] {
    return students.map(student => {
      const { permissionId, form, gender, firstName, lastName, id, house } = student;
      return {
        permissionId,
        form,
        house,
        gender,
        firstName,
        lastName,
        id
      };
    });
  }

  getDefaultItemsFilter(team, forms, houses) {
    const { gender, houseId, ages = [] } = team;
    const genderArrayConverted = getUserGenderArrayConvertedFromEventGender(gender);

    return typeof houseId !== 'undefined'
      ? {
          firstName: '',
          lastName: '',
          gender: genderArrayConverted,
          forms: [],
          ages: ages.map(String),
          houses: houses.map(house => house.id)
        }
      : {
          firstName: '',
          lastName: '',
          ages: ages.map(String),
          gender: genderArrayConverted,
          forms: []
        };
  }

  getItemsAndItemsAccumulator() {
    const { user } = this.props;
    const { itemsAccumulatorFilters, forms, houses } = this.state;

    const teamId = this.getTeamId();
    const options = {
      forms: forms,
      houses: houses
    };
    const where = getServerFieldSectionWhere(itemsAccumulatorFilters, options);

    const getTeamPlayersInitialPromise = getAllSchoolTeamPlayers(user, teamId);
    const getTeamPlayersPromise = getAllSchoolTeamPlayers(user, teamId, where);
    const getTeamPlayersCountPromise = getSchoolTeamPlayersCount(user, teamId, where);

    let teamPlayersInitial, teamPlayers, teamPlayersCount;

    return BPromise.all([getTeamPlayersInitialPromise, getTeamPlayersPromise, getTeamPlayersCountPromise])
      .then(([_teamPlayersInitial, _teamPlayers, _teamPlayersCount]) => {
        teamPlayersInitial = _teamPlayersInitial;
        teamPlayers = _teamPlayers;
        teamPlayersCount = _teamPlayersCount;

        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        const filter = this.getItemsFilter(1, teamPlayersInitialNormalized, []);

        const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
        const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

        return BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]);
      })
      .then(([students, studentsCount]) => {
        return {
          teamPlayersInitial,
          teamPlayers,
          teamPlayersCount,
          students,
          studentsCount
        };
      });
  }

  onItemClick = (index: number): void => {
    const { items, itemsSelected } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = itemsSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: [],
      itemsSelected: selectedItemsUpdated
    });
  };

  onItemAccumulatorClick = (index: number): void => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const selectedItem = itemsAccumulator[index];

    const selectedItemIndex = itemsAccumulatorSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsAccumulatorSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: selectedItemsUpdated,
      itemsSelected: []
    });
  };

  onAddClick = () => {
    const { itemsSelected, itemsAddBuffer, itemsAccumulatorInitial, itemsAccumulator, itemCurrentPage } = this.state;
    const { user } = this.props;

    const nextItemsAddBuffer = [...itemsAddBuffer, ...itemsSelected];

    const existingIds = new Set((itemsAccumulator || []).map(x => String(x.id)));
    const nextItemsAccumulator = [...itemsAccumulator, ...itemsSelected.filter(x => !existingIds.has(String(x.id)))];

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulatorInitial, nextItemsAddBuffer);
    const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
    const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false
      });
    });
  };

  onRemoveClick = () => {
    const {
      itemsAccumulatorSelected,
      itemsAddBuffer,
      itemsRemoveBuffer,
      itemsAccumulatorInitial,
      itemsAccumulator,
      itemCurrentPage
    } = this.state;
    const { user } = this.props;

    const selectedIds = new Set((itemsAccumulatorSelected || []).map(x => String(x.id)));
    const addBufferIds = new Set((itemsAddBuffer || []).map(x => String(x.id)));

    const selectedExistingParticipants = (itemsAccumulatorSelected || []).filter(x => !addBufferIds.has(String(x.id)));

    const nextItemsAddBuffer = (itemsAddBuffer || []).filter(x => !selectedIds.has(String(x.id)));

    const existingRemoveIds = new Set((itemsRemoveBuffer || []).map(x => String(x.id)));
    const nextItemsRemoveBuffer = [
      ...(itemsRemoveBuffer || []),
      ...selectedExistingParticipants.filter(x => !existingRemoveIds.has(String(x.id)))
    ];

    const nextItemsAccumulatorInitial = (itemsAccumulatorInitial || []).filter(
      itemAccumulatorInitial =>
        !nextItemsRemoveBuffer.some(
          nextItemRemoveBuffer => String(nextItemRemoveBuffer.id) === String(itemAccumulatorInitial.id)
        )
    );

    const nextItemsAccumulator = (itemsAccumulator || []).filter(
      itemAccumulator => !selectedIds.has(String(itemAccumulator.id))
    );

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulatorInitial, nextItemsAddBuffer);
    const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
    const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsRemoveBuffer: nextItemsRemoveBuffer,
        itemsAccumulatorInitial: nextItemsAccumulatorInitial,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length
      });
    });
  };

  onClickSave = () => {
    const { itemsAddBuffer, itemsRemoveBuffer, itemsAccumulatorInitial, assignmentChangedPlayerIds } = this.state;
    const { user } = this.props;

    // const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    const data: any = {
      updateFutureEvents: this.state.updateFutureEvents,
      add: itemsAddBuffer.map(item => ({
        userId: item.id,
        permissionId: item.permissionId,
        sportIds: item.sportIds,
        positionsBySport: item.positionsBySport
      })),
      update: itemsAccumulatorInitial
        .filter(item => assignmentChangedPlayerIds.includes(item.playerId))
        .map(item => ({ id: item.playerId, sportIds: item.sportIds, positionsBySport: item.positionsBySport })),
      remove: itemsRemoveBuffer.map(item => item.playerId)
    };

    this.setState({
      isLoading: true,
      saveError: ''
    });

    updateSchoolTeamPlayersBatch(user, teamId, data)
      .then(result => {
        if (!data.updateFutureEvents) return this.goBack();
        this.setState({ isLoading: false, saveResult: { updatedEvents: result.futureEventSync?.updatedEvents } });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isLoading: false,
          saveError:
            propz.get(error, ['response', 'data', 'details', 'text'], '') ||
            'The team or linked future events could not be saved. Please reload and try again.'
        });
      });
  };

  onTogglePlayerSport = (playerId: string, sportId: string) => {
    this.updatePlayerAssignment(playerId, item => {
      const teamSportIds = this.getTeamSportIds();
      const current = Array.isArray(item.sportIds) ? item.sportIds : teamSportIds;
      const sportIds = current.includes(sportId) ? current.filter(id => id !== sportId) : [...current, sportId];
      return { ...item, sportIds };
    });
  };

  onPlayerPositionChange = (playerId: string, sportId: string, positionId: string) => {
    this.updatePlayerAssignment(playerId, item => {
      const current = (item.positionsBySport || []).find(position => position.sportId === sportId) || { sportId };
      const positionsBySport = [...(item.positionsBySport || [])].filter(position => position.sportId !== sportId);
      positionsBySport.push({ ...current, positionId: positionId || undefined });
      return { ...item, positionsBySport };
    });
  };

  onPlayerSportFlagChange = (
    playerId: string,
    sportId: string,
    field: 'sub' | 'isCaptain' | 'isViceCaptain',
    value: boolean
  ) => {
    this.setState(state => {
      const changedUserIds = new Set<string>([playerId]);
      const updateItem = (item: Item): Item => {
        const current = (item.positionsBySport || []).find(position => position.sportId === sportId) || { sportId };
        const shouldClearOtherCaptain = field === 'isCaptain' && value && item.id !== playerId && current.isCaptain;
        if (item.id !== playerId && !shouldClearOtherCaptain) return item;
        if (shouldClearOtherCaptain) changedUserIds.add(item.id);
        const positionsBySport = [...(item.positionsBySport || [])].filter(position => position.sportId !== sportId);
        positionsBySport.push(
          item.id === playerId
            ? {
                ...current,
                [field]: value,
                ...(value && field === 'isCaptain' ? { isViceCaptain: false } : {}),
                ...(value && field === 'isViceCaptain' ? { isCaptain: false } : {})
              }
            : { ...current, isCaptain: false }
        );
        return { ...item, positionsBySport };
      };
      const itemsAccumulatorInitial = state.itemsAccumulatorInitial.map(updateItem);
      const itemsAccumulator = state.itemsAccumulator.map(updateItem);
      const itemsAddBuffer = state.itemsAddBuffer.map(updateItem);
      const changedPersistedIds = state.itemsAccumulatorInitial
        .filter(item => changedUserIds.has(item.id) && item.playerId)
        .map(item => item.playerId as string);
      return {
        itemsAccumulatorInitial,
        itemsAccumulator,
        itemsAddBuffer,
        assignmentChangedPlayerIds: Array.from(new Set([...state.assignmentChangedPlayerIds, ...changedPersistedIds]))
      } as any;
    });
  };

  getTeamSportIds = (): string[] => {
    const { team } = this.state;
    return team.sportIds && team.sportIds.length ? team.sportIds : team.sportId ? [team.sportId] : [];
  };

  updatePlayerAssignment = (playerId: string, updater: (item: Item) => Item) => {
    this.setState(state => {
      const rosterPlayer = state.itemsAccumulatorInitial.find(item => item.id === playerId);
      const persistedPlayerId = rosterPlayer && rosterPlayer.playerId;
      return {
        itemsAccumulatorInitial: state.itemsAccumulatorInitial.map(item =>
          item.id === playerId ? updater(item) : item
        ),
        itemsAccumulator: state.itemsAccumulator.map(item => (item.id === playerId ? updater(item) : item)),
        itemsAddBuffer: state.itemsAddBuffer.map(item => (item.id === playerId ? updater(item) : item)),
        assignmentChangedPlayerIds:
          persistedPlayerId && !state.assignmentChangedPlayerIds.includes(persistedPlayerId)
            ? [...state.assignmentChangedPlayerIds, persistedPlayerId]
            : state.assignmentChangedPlayerIds
      };
    });
  };

  onItemsFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'forms') {
      nextFilters.ages = [];
    }

    if (filterField === 'ages') {
      nextFilters.forms = [];
    }
    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsFilters: nextFilters
    });
  };

  onItemsAccumulatorFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsAccumulatorFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsAccumulatorFilters: nextFilters
    });
  };

  onItemsFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsFilter } = this.state;

    this.setState({
      isShowItemsFilter: !isShowItemsFilter
    });
  };

  onItemsAccumulatorFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsAccumulatorFilter } = this.state;

    this.setState({
      isShowItemsAccumulatorFilter: !isShowItemsAccumulatorFilter
    });
  };

  getItemsFilter(page, itemsAccumulator, itemsAddBuffer, isAllItems = false) {
    const { itemsFilters, team, forms, houses, itemsSearch } = this.state;
    const { houseId } = team;
    const isHouseIdExist = typeof houseId !== 'undefined';

    const {
      gender: itemsFiltersGender,
      ages: itemsFiltersAges = [],
      firstName: itemsFiltersFirstName = '',
      lastName: itemsFiltersLastName = '',
      forms: itemsFiltersForms = [],
      houses: itemsFiltersHouses = []
    } = itemsFilters;

    let where = {
      gender: {
        $in: itemsFiltersGender
      }
    };

    const allItems = [...itemsAccumulator, ...itemsAddBuffer];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (itemsFiltersForms.length > 0) {
      propz.set(where, ['formId', '$in'], itemsFiltersForms);
    } else {
      const ages = itemsFiltersAges.length > 0 ? itemsFiltersAges : AGE_GROUPS.ENGLISH.map((age, index) => index);
      const formIds = forms.filter(form => ages.some(age => Number(form.age) === Number(age))).map(form => form.id);

      if (formIds.length > 0) {
        propz.set(where, ['formId', '$in'], formIds);
      }
    }

    if (isHouseIdExist) {
      propz.set(where, ['houseId'], houseId);
    }

    if (itemsFiltersHouses.length > 0) {
      propz.set(where, ['houseId', '$in'], itemsFiltersHouses);
    }

    let and = [];

    if (itemsFiltersFirstName.length > 0) {
      and.push({ firstName: { like: itemsFiltersFirstName, options: 'i' } });
    }

    if (itemsFiltersLastName.length > 0) {
      and.push({ lastName: { like: itemsFiltersLastName, options: 'i' } });
    }

    if (itemsSearch.trim().length > 0) {
      const searchValue = itemsSearch.trim();
      and.push({
        $or: [{ firstName: { like: searchValue, options: 'i' } }, { lastName: { like: searchValue, options: 'i' } }]
      });
    }

    if (and.length > 0) {
      propz.set(where, ['$and'], and);
    }

    const filter = {
      where: where,
      limit: isAllItems ? DEFAULT_LIMIT : LIMIT,
      skip: isAllItems ? 0 : (page - 1) * LIMIT,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };

    return filter;
  }

  itemsSetCurrentPageParams = (currentPage: number): void => {
    const { user } = this.props;
    const { itemsAccumulator, sortItemsColumnsName, sortItemsDirection, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });

    let orderForFilter = undefined;

    if (sortItemsColumnsName !== '' && sortItemsDirection !== '') {
      orderForFilter = `${sortItemsColumnsName} ${sortItemsDirection}`;
    }

    const filter = this.getItemsFilter(currentPage, itemsAccumulator, itemsAddBuffer);

    getSchoolStudentsWithoutClashes(user, filter).then(students => {
      const studentsNormalized = this.getStudentsNormalized(students);
      this.setState({
        itemCurrentPage: currentPage,
        items: studentsNormalized,
        isLoading: false
      });
    });
  };

  itemsOnApplyFilterClick = (isSilent = false) => {
    const { itemsAccumulator, itemsAddBuffer } = this.state;
    const requestId = ++this.itemsSearchRequestId;

    if (isSilent) {
      this.setState({ isItemsLoading: true });
    } else {
      this.setState({ isLoading: true });
    }

    const filter = this.getItemsFilter(1, itemsAccumulator, itemsAddBuffer);

    const { user } = this.props;

    const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
    const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      if (requestId !== this.itemsSearchRequestId) return;
      const studentsNormalized = this.getStudentsNormalized(students);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        isItemsLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsDirection: '',
        sortItemsColumnsName: ''
      });
    });
  };

  onItemsSearchChange = (itemsSearch: string) => {
    this.setState({ itemsSearch, isItemsLoading: true }, () => this.itemsOnApplyFilterClick(true));
  };

  itemsAccumulatorOnApplyFilterClick = () => {};
  /*itemsAccumulatorOnApplyFilterClick = () => {
    const { itemsAccumulatorFilters, itemsRemoveBuffer } = this.state;
    this.setState({
      isLoading: true
    });

    let where = getServerFieldSectionWhere(itemsAccumulatorFilters);
    const ninIds = itemsRemoveBuffer.map(item => item.id);
    propz.set(where, ['id', '$nin'], ninIds);

    const { user } = this.props;

    const teamId = this.getTeamId();

    const getTeamPlayersPromise = getAllSchoolTeamPlayers(user, teamId, where);
    const getTeamPlayersCountPromise = getSchoolTeamPlayersCount(user, teamId, where);

    BPromise.all([getTeamPlayersPromise, getTeamPlayersCountPromise]).then(([teamPlayers, teamPlayersCount]) => {
      const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
      this.setState({
        itemsAccumulator: teamPlayersNormalized,
        isLoading: false,
        itemsAccumulatorCount: teamPlayersCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: []
      });
    });
  };*/

  itemsOnClearFilterClick = () => {
    this.itemsSearchRequestId += 1;
    const { itemsAccumulatorInitial, itemsAddBuffer, team, forms, houses } = this.state;
    const { houseId } = team;
    const isHouseIdExist = typeof houseId !== 'undefined';

    const defaultItemsFilter = this.getDefaultItemsFilter(team, forms, houses);

    this.setState({
      isLoading: true,
      itemsFilters: defaultItemsFilter,
      itemsSearch: ''
    });

    const { gender: itemsFiltersGender, ages: itemsFiltersAges = [] } = defaultItemsFilter;

    let where = {
      gender: {
        $in: itemsFiltersGender
      }
    };

    const allItems = [...itemsAccumulatorInitial, ...itemsAddBuffer];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    const ages = itemsFiltersAges.length > 0 ? itemsFiltersAges : AGE_GROUPS.ENGLISH.map((age, index) => index);
    const formIds = forms.filter(form => ages.some(age => Number(form.age) === Number(age))).map(form => form.id);

    if (formIds.length > 0) {
      propz.set(where, ['formId', '$in'], formIds);
    }

    if (isHouseIdExist) {
      propz.set(where, ['houseId'], houseId);
    }

    const filter = {
      where: where,
      limit: LIMIT,
      skip: DEFAULT_SKIP,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };

    const { user } = this.props;

    const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
    const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: '',
        sortItemsDirection: '',
        isItemsFiltered: true,
        isShowItemsFilter: false
      });
    });
  };

  itemsAccumulatorOnClearFilterClick = () => {};

  /*itemsAccumulatorOnClearFilterClick = () => {
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const teamId = this.getTeamId();
    const { itemsRemoveBuffer } = this.state;

    const getTeamPlayersPromise = getAllSchoolTeamPlayers(user, teamId);
    const getTeamPlayersCountPromise = getSchoolTeamPlayersCount(user, teamId);

    BPromise.all([getTeamPlayersPromise, getTeamPlayersCountPromise]).then(([teamPlayers, teamPlayersCount]) => {
      const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
      const nextTeamPlayersNormalized = teamPlayersNormalized.filter(teamPlayerNormalized =>
        itemsRemoveBuffer.every(item => item.id !== teamPlayerNormalized.id)
      );

      this.setState({
        itemsAccumulator: nextTeamPlayersNormalized,
        isLoading: false,
        itemsAccumulatorCount: teamPlayersCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemsAccumulatorFilters: {}
      });
    });
  };*/

  goBack = () => {
    const { history, location } = this.props;
    const search = propz.get(location, ['state', 'search'], '');

    const teamId = this.getTeamId();

    history.push({
      pathname: '/teams',
      search,
      state: { teamId }
    });
  };

  goBackWithOrWithoutConfirmation = () => {
    const { itemsAddBuffer, itemsRemoveBuffer } = this.state;
    const isChangesInTeamExist = itemsAddBuffer.length > 0 || itemsRemoveBuffer.length > 0;

    isChangesInTeamExist ? this.onConfirmationExitWithoutSavingModalOpen() : this.goBack();
  };

  renderConfirmationExitWithoutSavingModal = () => {
    const { isExitConfirmationModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isExitConfirmationModalOpen}
        title="Discard unsaved changes?"
        showFooter={false}
        isBodyBold={false}
        customClass="teamPlayersWarningModal"
        onCloseClick={this.onConfirmationExitWithoutSavingModalClose}
      >
        <div className="teamPlayersWarning">
          <div className="teamPlayersWarning__icon">!</div>
          <div className="teamPlayersWarning__copy">
            <strong>Your team changes have not been saved.</strong>
            <p>If you leave now, added and removed players will be lost.</p>
          </div>
          <div className="teamPlayersWarning__actions">
            <button
              type="button"
              className="teamPlayersPage__cancel"
              onClick={this.onConfirmationExitWithoutSavingModalClose}
            >
              Keep editing
            </button>
            <button type="button" className="teamPlayersWarning__discard" onClick={this.goBack}>
              Discard changes
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  };

  onConfirmationExitWithoutSavingModalOpen = () => {
    this.setState({
      isExitConfirmationModalOpen: true
    });
  };

  onConfirmationExitWithoutSavingModalClose = () => {
    this.setState({
      isExitConfirmationModalOpen: false
    });
  };

  onSelectAllItemsClick = () => {
    const { itemsSelected, itemsAddBuffer, itemsAccumulatorInitial, itemCurrentPage } = this.state;
    this.setState({
      isLoading: true
    });

    const user = this.props.user;
    const nextItemsAddBuffer = [...itemsAddBuffer, ...itemsSelected];
    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulatorInitial, nextItemsAddBuffer, true);

    getSchoolStudentsWithoutClashes(user, filter).then(items => {
      const itemsFiltered = items.filter(item => {
        return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
      });

      const studentsNormalizedFiltered = this.getStudentsNormalized(itemsFiltered);

      const nextSelectedItems = [...itemsSelected, ...studentsNormalizedFiltered];

      this.setState({
        itemsSelected: nextSelectedItems,
        isSelectAllItemsChecked: true,
        itemsAccumulatorSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsOnPageClick = () => {
    const { items, itemsSelected } = this.state;

    const itemsFiltered = items.filter(item => {
      return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsSelected, ...itemsFiltered];

    this.setState({
      itemsSelected: nextSelectedItems,
      isSelectAllItemsChecked: true,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onUnselectAllItemsClick = () => {
    this.setState({
      itemsSelected: [],
      isSelectAllItemsChecked: false,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onSelectAllItemsAccumulatorClick = () => {
    const { itemsAccumulatorSelected, itemsAccumulatorFilters } = this.state;
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const teamId = this.getTeamId();
    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);

    getAllSchoolTeamPlayers(user, teamId, where).then(teamPlayers => {
      const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);

      const teamPlayersFiltered = teamPlayersNormalized.filter(teamPlayer => {
        return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== teamPlayer.id);
      });

      const nextSelectedItems = [...itemsAccumulatorSelected, ...teamPlayersFiltered];

      this.setState({
        itemsAccumulatorSelected: nextSelectedItems,
        isSelectAllItemsAccumulatorChecked: true,
        itemsSelected: [],
        isSelectAllItemsChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsAccumulatorOnPageClick = () => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;

    const itemsFiltered = itemsAccumulator.filter(item => {
      return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsAccumulatorSelected, ...itemsFiltered];

    this.setState({
      itemsAccumulatorSelected: nextSelectedItems,
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onUnselectAllItemsAccumulatorClick = () => {
    this.setState({
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onSortItemsClick = (sortField: string) => {
    const { sortItemsDirection, sortItemsColumnsName, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    const order = getOrder(sortField, sortItemsDirection, sortItemsColumnsName) as TABLE_SORT_DIRECTION;
    const orderForFilter = `${sortField} ${order}`;

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer);
    const { user } = this.props;
    const getSchoolStudentsPromise = getSchoolStudentsWithoutClashes(user, filter);
    const getSchoolStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter.where);

    BPromise.all([getSchoolStudentsPromise, getSchoolStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);
      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: sortField,
        sortItemsDirection: order
      });
    });
  };

  onSortItemsAccumulatorClick = (sortField: string) => {};

  render() {
    const {
      items,
      isLoading,
      itemsSelected,
      itemsAccumulatorSelected,
      itemsAccumulator,
      itemsAccumulatorInitial,
      itemsFilters,
      isShowItemsFilter,
      isItemsFiltered,
      itemsCount,
      itemsAccumulatorCount,
      itemCurrentPage,
      itemsAccumulatorFilters,
      isShowItemsAccumulatorFilter,
      isItemsAccumulatorFiltered,
      isSelectAllItemsChecked,
      isSelectAllItemsAccumulatorChecked,
      sortItemsDirection,
      sortItemsColumnsName,
      sortItemsAccumulatorDirection,
      sortItemsAccumulatorColumnsName,
      itemsAddBuffer,
      itemsRemoveBuffer,
      assignmentChangedPlayerIds,
      forms,
      houses,
      team,
      itemsHiddenFields,
      itemsAccumulatorHiddenFields
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const { user } = this.props;
    const { activeSchool } = user;
    const { name, gender } = team;
    const { ageGroupsNaming } = activeSchool;

    const itemsFiltersOptions = {
      ages: getSelectOptionForAge(forms, ageGroupsNaming),
      gender: getSelectOptionForGender(gender),
      forms: getSelectOptionForForms(forms),
      houses: getSelectOptionForHouses(houses)
    };

    const itemsAccumulatorFiltersOptions = {};

    const visibleItemsColumns = ITEMS_COLUMNS.filter(col => !itemsHiddenFields.has(col.field));
    const visibleAccumulatorColumns = ITEMS_ACCUMULATOR_COLUMNS.filter(
      col => !itemsAccumulatorHiddenFields.has(col.field)
    );
    const teamSports = team.sports && team.sports.length ? team.sports : team.sport ? [team.sport] : [];
    const rosterPlayers = [...itemsAccumulatorInitial, ...itemsAddBuffer].filter(
      item => !itemsRemoveBuffer.some(removed => removed.id === item.id)
    );
    const isAssignmentsMode = this.getEditorMode() === 'assignments';
    const pendingChanges = isAssignmentsMode
      ? assignmentChangedPlayerIds.length
      : itemsAddBuffer.length + itemsRemoveBuffer.length;

    return (
      <>
        {this.renderConfirmationExitWithoutSavingModal()}
        <SimpleModal
          isOpen={!!this.state.saveResult}
          title="Team roster saved"
          showFooter={false}
          isBodyBold={false}
          customClass="teamPlayersWarningModal"
          onCloseClick={this.goBack}
        >
          <div className="teamPlayersWarning teamPlayersWarning--result">
            <div className="teamPlayersWarning__copy" role="status">
              <strong>
                {this.state.saveResult?.updatedEvents > 0
                  ? `${this.state.saveResult.updatedEvents} future events updated.`
                  : this.state.saveResult?.updatedEvents === 0
                  ? 'No linked future events were found.'
                  : 'The server did not confirm future event synchronization.'}
              </strong>
              {this.state.saveResult?.updatedEvents === 0 && (
                <p>
                  Past events are excluded. Club rosters imported before source tracking was added must have their
                  source teams linked again through Choose existing team.
                </p>
              )}
              {this.state.saveResult && this.state.saveResult.updatedEvents === undefined && (
                <p>
                  The team was saved, but event synchronization could not be verified. Check that the latest backend
                  build is installed.
                </p>
              )}
            </div>
            <div className="teamPlayersWarning__actions">
              <button type="button" className="teamPlayersPage__save" onClick={this.goBack}>
                Done
              </button>
            </div>
          </div>
        </SimpleModal>
        <div className="teamPlayersPage__header">
          <div className="teamPlayersPage__breadcrumb">
            Teams <span>/</span> {isAssignmentsMode ? 'Sport assignments' : 'Roster'}
          </div>
          <div className="teamPlayersPage__titleRow">
            <button type="button" className="teamPlayersPage__back" onClick={this.goBackWithOrWithoutConfirmation}>
              ←
            </button>
            <div>
              <h1>{isAssignmentsMode ? 'Edit sport assignments' : 'Manage roster'}</h1>
              <p>
                {name}
                {team.season ? ` · ${team.season}` : ''}
              </p>
            </div>
            <span className="teamPlayersPage__changes">{pendingChanges} pending changes</span>
          </div>
        </div>
        <label className="teamPlayersPage__syncOption">
          <input
            type="checkbox"
            checked={this.state.updateFutureEvents}
            onChange={event => this.setState({ updateFutureEvents: event.target.checked })}
          />
          <span>
            <strong>Update all linked future events</strong>
            <small>
              Apply this team's latest roster to ordinary, club and tournament events. Separately adjusted event rosters
              will also be replaced. Past events stay unchanged. New pupils will also be enrolled in the corresponding
              clubs and tournament teams.
            </small>
          </span>
        </label>
        {!isAssignmentsMode && (
          <TwoPanelEditor
            onItemsSearchChange={this.onItemsSearchChange}
            itemsSearchValue={this.state.itemsSearch}
            isItemsLoading={this.state.isItemsLoading}
            itemsModernPagination
            itemsSearchByNameOnly
            //items
            items={items}
            itemsTitle={'Available players'}
            itemsColumns={visibleItemsColumns}
            itemsSelected={itemsSelected}
            onItemClick={this.onItemClick}
            //items filters
            onItemsFilterChange={this.onItemsFilterChange}
            itemsFilters={itemsFilters}
            itemsFiltersOptions={itemsFiltersOptions}
            isShowItemsFilter={isShowItemsFilter}
            isItemsFiltered={isItemsFiltered}
            onItemsFilterClick={this.onItemsFilterClick}
            //accumulator
            itemsAccumulator={itemsAccumulator}
            itemsAccumulatorTitle={'Team members'}
            itemsAccumulatorColumns={visibleAccumulatorColumns}
            onItemAccumulatorClick={this.onItemAccumulatorClick}
            itemsAccumulatorSelected={itemsAccumulatorSelected}
            //accumulator filters
            onItemsAccumulatorFilterChange={this.onItemsAccumulatorFilterChange}
            itemsAccumulatorFilters={itemsAccumulatorFilters}
            itemsAccumulatorFiltersOptions={itemsAccumulatorFiltersOptions}
            isShowItemsAccumulatorFilter={isShowItemsAccumulatorFilter}
            isItemsAccumulatorFiltered={isItemsAccumulatorFiltered}
            onItemsAccumulatorFilterClick={this.onItemsAccumulatorFilterClick}
            //buttons
            onAddClick={this.onAddClick}
            onRemoveClick={this.onRemoveClick}
            //counts
            itemsCount={itemsCount}
            itemsAccumulatorCount={itemsAccumulatorCount}
            //current pages
            itemAccumulatorCurrentPage={1}
            itemCurrentPage={itemCurrentPage}
            itemsSetCurrentPageParams={this.itemsSetCurrentPageParams}
            //items filter buttons
            itemsOnApplyFilterClick={this.itemsOnApplyFilterClick}
            itemsOnClearFilterClick={this.itemsOnClearFilterClick}
            //items accumulator filter buttons
            itemsAccumulatorOnApplyFilterClick={this.itemsAccumulatorOnApplyFilterClick}
            itemsAccumulatorOnClearFilterClick={this.itemsAccumulatorOnClearFilterClick}
            //items select checkbox
            onSelectAllItemsClick={this.onSelectAllItemsClick}
            onSelectAllItemsOnPageClick={this.onSelectAllItemsOnPageClick}
            onUnselectAllItemsClick={this.onUnselectAllItemsClick}
            isSelectAllItemsChecked={isSelectAllItemsChecked}
            //items accumulator select checkbox
            onSelectAllItemsAccumulatorClick={this.onSelectAllItemsAccumulatorClick}
            onSelectAllItemsAccumulatorOnPageClick={this.onSelectAllItemsAccumulatorOnPageClick}
            onUnselectAllItemsAccumulatorClick={this.onUnselectAllItemsAccumulatorClick}
            isSelectAllItemsAccumulatorChecked={isSelectAllItemsAccumulatorChecked}
            //items sort
            sortItemsDirection={sortItemsDirection}
            sortItemsColumnsName={sortItemsColumnsName}
            onSortItemsClick={this.onSortItemsClick}
            //items accumulator sort
            sortItemsAccumulatorDirection={sortItemsAccumulatorDirection}
            sortItemsAccumulatorColumnsName={sortItemsAccumulatorColumnsName}
            onSortItemsAccumulatorClick={this.onSortItemsAccumulatorClick}
            itemsAddBuffer={itemsAddBuffer}
            itemsRemoveBuffer={itemsRemoveBuffer}
            isSourceFirst={true}
            //column visibility – items
            itemsAllColumns={ITEMS_COLUMNS}
            itemsHiddenFields={itemsHiddenFields}
            onToggleItemsColumn={this.onToggleItemsColumn}
            isItemsColumnToggleable={this.isColumnToggleable}
            //column visibility – accumulator
            itemsAccumulatorAllColumns={ITEMS_ACCUMULATOR_COLUMNS}
            itemsAccumulatorHiddenFields={itemsAccumulatorHiddenFields}
            onToggleItemsAccumulatorColumn={this.onToggleItemsAccumulatorColumn}
            isItemsAccumulatorColumnToggleable={this.isColumnToggleable}
          />
        )}
        {isAssignmentsMode && teamSports.length > 0 && (
          <section className="teamPlayersPage__sportRoster">
            <div className="teamPlayersPage__assignmentIntro">
              <div>
                <span>Sport setup</span>
                <h2>Positions and responsibilities</h2>
                <p>Review every sport below, then set availability, position and leadership for each team member.</p>
              </div>
              <strong>{rosterPlayers.length} team members</strong>
            </div>
            <div className="teamPlayersPage__sportSections">
              {teamSports.map(sport => {
                const positions = propz.get(sport, ['field', 'positions'], []);
                const assignedCount = rosterPlayers.filter(player => {
                  const playerSportIds = Array.isArray(player.sportIds) ? player.sportIds : this.getTeamSportIds();
                  return playerSportIds.includes(sport.id);
                }).length;
                return (
                  <section className="teamPlayersPage__sportSection" key={sport.id}>
                    <header className="teamPlayersPage__sportSectionHead">
                      <div>
                        <span>Sport</span>
                        <h3>{sport.name}</h3>
                      </div>
                      <strong>
                        {assignedCount} of {rosterPlayers.length} included
                      </strong>
                    </header>
                    <div className="teamPlayersPage__sportPlayers">
                      {rosterPlayers.map(player => {
                        const playerSportIds = Array.isArray(player.sportIds)
                          ? player.sportIds
                          : this.getTeamSportIds();
                        const isIncluded = playerSportIds.includes(sport.id);
                        const assignment = (player.positionsBySport || []).find(item => item.sportId === sport.id);
                        return (
                          <div
                            className={`teamPlayersPage__sportPlayer ${isIncluded ? 'is-included' : 'is-excluded'}`}
                            key={player.id}
                          >
                            <label className="teamPlayersPage__playerIdentity">
                              <input
                                type="checkbox"
                                checked={isIncluded}
                                onChange={() => this.onTogglePlayerSport(player.id, sport.id)}
                              />
                              <i aria-hidden="true">
                                {`${player.firstName || ''}${player.lastName || ''}`.slice(0, 2).toUpperCase()}
                              </i>
                              <span>
                                <strong>
                                  {player.firstName} {player.lastName}
                                </strong>
                                <small>
                                  {isIncluded ? `Included in ${sport.name}` : `Not included in ${sport.name}`}
                                </small>
                              </span>
                            </label>
                            <label className="teamPlayersPage__position">
                              <span className="sr-only">Position</span>
                              <select
                                value={(assignment && assignment.positionId) || ''}
                                disabled={!isIncluded}
                                onChange={event => this.onPlayerPositionChange(player.id, sport.id, event.target.value)}
                              >
                                <option value="">No position</option>
                                {positions.map(position => (
                                  <option key={position._id} value={position._id}>
                                    {position.name}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <div className="teamPlayersPage__sportFlags" aria-label="Player roles">
                              {[
                                { field: 'isCaptain' as const, label: 'C', title: 'Captain' },
                                { field: 'isViceCaptain' as const, label: 'VC', title: 'Vice captain' },
                                { field: 'sub' as const, label: 'Sub', title: 'Substitute' }
                              ].map(role => {
                                const checked = Boolean(assignment && assignment[role.field]);
                                return (
                                  <label className="teamPlayersPage__sportFlag" key={role.field} title={role.title}>
                                    <input
                                      type="checkbox"
                                      disabled={!isIncluded}
                                      checked={checked}
                                      aria-label={role.title}
                                      onChange={event =>
                                        this.onPlayerSportFlagChange(
                                          player.id,
                                          sport.id,
                                          role.field,
                                          event.target.checked
                                        )
                                      }
                                    />
                                    <span>{role.label}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </section>
                );
              })}
            </div>
          </section>
        )}
        {this.state.saveError && (
          <div className="teamPlayersPage__syncError" role="alert">
            {this.state.saveError}
          </div>
        )}
        <div className="teamPlayersPage__footer">
          <button type="button" className="teamPlayersPage__cancel" onClick={this.goBackWithOrWithoutConfirmation}>
            Cancel
          </button>
          <button
            type="button"
            className="teamPlayersPage__save"
            onClick={this.onClickSave}
            disabled={itemsAddBuffer.length + itemsRemoveBuffer.length + assignmentChangedPlayerIds.length === 0}
          >
            {isAssignmentsMode ? 'Save assignments' : 'Save roster'}
          </button>
        </div>
      </>
    );
  }
}
